import { Injectable, Inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert.service';
import { Location } from '@angular/common';
import { WINDOW } from '../shared/providers/window';
import { TRANSLATE } from '../../shared/classes/translatable';


@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {
    constructor(
        @Inject(WINDOW) private window: Window,
        private alertService: AlertService,
        private router: Router,
        private location: Location
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            let error;
            if (!err.error && !err.statusText) {
                return throwError(err);
            } else {
                error = err.error.message || err.statusText;
            }
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                if (!this.router.url.includes("reset-password") && !this.router.url.includes("validation-facture")) {
                    this.router.navigate(['/login']);
                }
                this.alertService.error(error);
            } else if (err.status === 403) {
                if (err.error instanceof ArrayBuffer) {
                    this.alertService.error(TRANSLATE('Vous ne disposez pas de droits suffisants pour réaliser cette action'), false, true);
                } else {
                    this.alertService.error(error, false, true);
                }
            } else if (err.status === 404) {
                // En cas de 404 redirige sur la page précédente
                this.alertService.error(error, false, true);
                this.location.back();
            } else {
                // Toutes les autres erreurs
                this.alertService.error(error, false, true);
            }

            return throwError(err.error);
        }));
    }
}
